// extracted by mini-css-extract-plugin
module.exports = {"name":"ulogo_name_2H_AQ"};